export const DEFAULT_LESSON_MINUTES = 15;
export const LESSON_DURATION_SECONDS = DEFAULT_LESSON_MINUTES * 60;
export const SMALL_INLINE_ICON_SIZE = 15;
export const STATUS_ICON_SIZE = 22;